import { Link } from "react-router-dom";
import { Crown, Facebook, Instagram, Lock } from "lucide-react";

export default function Footer({ settings }) {
  return (
    <footer data-testid="site-footer" className="border-t border-[#D4AF37]/20 bg-black">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid gap-14 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <Crown className="h-7 w-7 text-[#D4AF37]" strokeWidth={1} />
              <span className="font-script text-4xl text-[#D4AF37]">D'La Valentina</span>
            </div>
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-neutral-400">
              The Queen of Pageants. Crowning dreams from little stars of 3 to timeless icons of 50 — on stages across the world.
            </p>
            <div className="mt-8 flex gap-4">
              {settings.facebook_url && (
                <a data-testid="footer-facebook" href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="border border-white/15 p-3 text-neutral-300 transition-all duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]" aria-label="Facebook">
                  <Facebook className="h-4 w-4" strokeWidth={1} />
                </a>
              )}
              {settings.instagram_url && (
                <a data-testid="footer-instagram" href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="border border-white/15 p-3 text-neutral-300 transition-all duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]" aria-label="Instagram">
                  <Instagram className="h-4 w-4" strokeWidth={1} />
                </a>
              )}
            </div>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">The House</h4>
            <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400">
              <li><a href="#about" data-testid="footer-link-about" className="transition-colors hover:text-[#D4AF37]">About the Legacy</a></li>
              <li><a href="#pageants" data-testid="footer-link-pageants" className="transition-colors hover:text-[#D4AF37]">Pageant Categories</a></li>
              <li><a href="#gallery" data-testid="footer-link-gallery" className="transition-colors hover:text-[#D4AF37]">Gallery</a></li>
              <li><a href="/register" data-testid="footer-link-register" className="transition-colors hover:text-[#D4AF37]">Register for a Pageant</a></li>
              <li><a href="/events/mrs-south-india-2026" data-testid="footer-link-event" className="transition-colors hover:text-[#D4AF37]">Mrs South India 2026</a></li>
              <li><a href="#news" data-testid="footer-link-news" className="transition-colors hover:text-[#D4AF37]">News & Press</a></li>
              <li><a href="#contact" data-testid="footer-link-contact" className="transition-colors hover:text-[#D4AF37]">Contact the House</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Reach the Throne</h4>
            <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400">
              <li data-testid="footer-phone">{settings.contact_phone1} · {settings.contact_phone2}</li>
              <li data-testid="footer-email">{settings.contact_email}</li>
              <li data-testid="footer-address">{settings.contact_address}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 text-[11px] uppercase tracking-[0.25em] text-neutral-500 sm:flex-row lg:px-10">
          <span>© 2026 D'La Valentina — All Rights Reserved</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="flex items-center gap-2 transition-colors hover:text-[#D4AF37]">
            <Lock className="h-3 w-3" strokeWidth={1.5} /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
